import 'C:\\Projects\\genkei\\zumeco\\static\\doodle\\view\\Panel.tsx.esbuild-plugin-linaria.css';
import { css, cx } from '@linaria/core';
import { forwardRef } from 'preact/compat';
import { COLOR_PANEL_BACK, COLOR_PANEL_SHADOW } from '../../shared/colors';
import { StyleType } from './StyleType';
export const Panel = forwardRef<HTMLDivElement, {
  className?: string;
  style?: StyleType;
  children: any;
}>(({
  className,
  style,
  children
}, ref) => <div ref={ref} className={cx("d1z10j7o", className)} style={style}>
      {children}
    </div>);